export default __webpack_public_path__ + "static/media/woocommerce-customthankyou.575f9d7f.gif";